import { EDistanceId } from './Types';

export class DistanceResponse {
  id!: EDistanceId;
  distance!: number;
}
